import { NgModule } from '@angular/core';
import { BallotErrorModalComponent} from './ballot-error-modal.component';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [
    BallotErrorModalComponent,
  ],
  exports: [
    BallotErrorModalComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class BallotErrorModalModule { }
